import { render, staticRenderFns } from "./DeliverableDropdown.vue?vue&type=template&id=0974c3ae&"
import script from "./DeliverableDropdown.vue?vue&type=script&lang=js&"
export * from "./DeliverableDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports